import React from 'react'

export const compactImage = (src, size="compact") => {
    return src?.replace('.png', `_${size}.png`) || ""
}

const ColorOption = ({ product, handleSetColor = () => { }, currColor = {} }) => {
    if (!product) return null


    return (
        <div className={`color-option ${currColor?.id === product?.id ? 'active' : currColor?.id + ' ' + product?.id}`} onClick={() => handleSetColor(product)} >
            <div className="image">
                <img src={product.images?.length ? compactImage(product.images[0].src) : compactImage(product.image?.src) ? product.image.src : product.image || ""} alt={product.title} />
            </div>
        </div>
    )
}

export default ColorOption
